import React, { Component } from 'react'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import { SuccessBadges } from 'components/misc'
import { meta } from 'helpers/decorators'

@meta({
  title: 'Register participant',
  intlKey: 'pageTitle.register_participant'
})
class Success extends Component {
  render() {
    // const isOnline = this.props.paymentMethod === PAYMENT_TYPES.online.id

    return (
      <div className="row">
        <div className="col-xs-12">
          <h1 className="beta">
            <span
              className="ico ico--checked"
              style={{ position: 'relative', top: 5, paddingRight: 15 }}
            />
            <FormattedMessage
              id="moduleTitle.your_registration_is_complete"
              defaultMessage="Your registration is complete"
            />
          </h1>
          <h2 className="reset-margin--top">
            <span
              className="ico ico--email"
              style={{ position: 'relative', top: 5, paddingRight: 15 }}
            />
            <FormattedMessage
              id="moduleTitle.we_have_sent_you_an_email"
              defaultMessage="We have sent you an email with an activation link."
            />
          </h2>
          {/* {isOnline && <h2 className="reset-margin--top">
            <span
              className="ico ico--email"
              style={{ position: 'relative', top: 5, paddingRight: 15 }}
            />
            <FormattedMessage
              id="moduleTitle.we_have_sent_you_payment_link"
              defaultMessage="We have sent you an email with a link to the Payment Gateway."
            />
          </h2>} */}
          <p className="desc">
            <FormattedHTMLMessage
              id="label.youll_receive_a_notification"
              defaultMessage="You'll receive a notification when your Award Leader has approved your registration. You can log on to the ORB Next Generation <a>here</a> (until your Award leader has approved your registration you will only have limited functionality)."
            />
          </p>
          <SuccessBadges />
        </div>
      </div>
    )
  }
}

export default Success
